import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import * as styles from "./PaginationNews-tw-styles"
import { PREVIOUS, NEXT } from "../../constants/label.constants"
import { gaEventClick } from "../../constants/gtm.constants"
import Button from "../UI/Button/Button"
import { usePaginatorNews } from "../../hooks/usePaginatorNews"

const PaginationNews = props => {
  let {
    currentPage = 1,
    totalPages,
    onPageChange,
    variant,
    hideAtFirst,
    pageSize,
    totalCount,
  } = props

  let style = styles[variant] || styles["defaultStyle"]
  const siblingCount = 3
  const DOTS = "DOTS"
  const paginationData = usePaginatorNews({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })
  const nextPage = () => {
    if (currentPage !== totalPages) onPageChange(currentPage + 1)
  }

  const prevPage = () => {
    if (currentPage !== 1) onPageChange(currentPage - 1)
  }

  return (
    <div className={style?.paginationWrap}>
      <ul className={style?.pagination}>
        <li
          className={`${
            currentPage <= 1 ? (hideAtFirst ? "hidden" : "disabled") : ""
          } ${style?.paginationPrevItem} `}
        >
          <Button
            className={style?.pageLink}
            onClick={prevPage}
            gaEventClass={gaEventClick}
            dataActionDetail={PREVIOUS}
          >
            {PREVIOUS}
          </Button>
        </li>

        {paginationData?.map((pageNumber, idx) => {
          if (pageNumber === DOTS) {
            return (
              <li key={idx} className="pagination-item dots">
                &#8230;
              </li>
            )
          }

          return (
            <li
              key={idx}
              className={classnames(style?.paginationItem, {
                selected: pageNumber === currentPage,
              })}
            >
              <Button
                className={style?.paginationbt}
                onClick={() => onPageChange(pageNumber)}
                gaEventClass={gaEventClick}
                dataActionDetail={`Page Number ${pageNumber}`}
              >
                {pageNumber}
              </Button>
            </li>
          )
        })}

        <li
          className={`${
            currentPage >= totalPages
              ? hideAtFirst
                ? "hidden"
                : "disabled"
              : ""
          } ${style?.paginationNextItem}`}
        >
          <Button
            className={style?.pageLink}
            onClick={nextPage}
            gaEventClass={gaEventClick}
            dataActionDetail={NEXT}
          >
            {NEXT}
          </Button>
        </li>
      </ul>
    </div>
  )
}

PaginationNews.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  hideAtFirst: PropTypes.bool,
  onPageChange: PropTypes.func,
  variant: PropTypes.string,
  pageSize: PropTypes.any,
  totalCount: PropTypes.any,
}

export default PaginationNews
